import { OrderAPI, PaymentAPI } from "@/lib/api";

// Pemuat Midtrans Snap.js + helper membuka popup pembayaran.
// Konfigurasi (client key, sandbox/production) diambil dari backend agar cukup diatur di backend/.env.
let configPromise = null;
let scriptPromise = null;

export function getMidtransConfig() {
  if (!configPromise) {
    configPromise = PaymentAPI.midtransConfig().catch(() => ({ enabled: false }));
  }
  return configPromise;
}

function loadSnap(cfg) {
  if (window.snap) return Promise.resolve(window.snap);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = cfg.is_production
        ? "https://app.midtrans.com/snap/snap.js"
        : "https://app.sandbox.midtrans.com/snap/snap.js";
      s.setAttribute("data-client-key", cfg.client_key);
      s.onload = () => resolve(window.snap);
      s.onerror = () => { scriptPromise = null; reject(new Error("Gagal memuat Midtrans")); };
      document.body.appendChild(s);
    });
  }
  return scriptPromise;
}

// Buka popup Snap untuk sebuah token. Resolve "success" | "pending" | "error" | "closed"
// saat popup selesai/ditutup. Status resmi tetap dari notifikasi Midtrans ke server.
export async function openSnap(token) {
  const cfg = await getMidtransConfig();
  if (!cfg.enabled) throw new Error("Pembayaran online belum aktif");
  const snap = await loadSnap(cfg);
  return new Promise((resolve) => {
    snap.pay(token, {
      onSuccess: () => resolve("success"),
      onPending: () => resolve("pending"),
      onError: () => resolve("error"),
      onClose: () => resolve("closed"),
    });
  });
}

// Buka popup Snap untuk sebuah pesanan. `payment` = { token, redirect_url } (opsional; bila
// tidak ada, token diminta ke backend). Resolve dengan pesanan terbaru setelah popup ditutup.
export async function payOrderWithMidtrans(order, payment) {
  const cfg = await getMidtransConfig();
  if (!cfg.enabled) throw new Error("Pembayaran online belum aktif");
  const pay = payment?.token ? payment : await OrderAPI.midtransToken(order.id);
  const result = await openSnap(pay.token);
  // Status resmi tetap dari notifikasi Midtrans; sync ini mempercepat tampilan.
  const latest = await OrderAPI.midtransSync(order.id).catch(() => null);
  return { result, order: latest || order };
}
